import React from 'react';
// import "../../assets/css/master.css";

import TemplateDashboard from "../../../components/TemplateDashboard";
import AlumnosNotasContent from './components/AlumnosNotasContent';

const AlumnosNotasListado = () => {

    return (
        <>

            <TemplateDashboard>
                <AlumnosNotasContent />
            </TemplateDashboard>

        </>
    )
};

export default AlumnosNotasListado;